// removed by extract-text-webpack-plugin
module.exports = {"spinner":"c-Spinner__spinner","spinner__item":"c-Spinner__spinner__item","SpinnerAnimation":"c-Spinner__SpinnerAnimation","animating":"c-Spinner__animating"};